export const SCREEN_SERVICE_CONFIG_PROVIDER = 'SCREEN_SERVICE_CONFIG_PROVIDER';
export const SCREEN_SERVICE_CONFIG_DYNAMIC_PROVIDER = 'SCREEN_SERVICE_CONFIG_DYNAMIC_PROVIDER';
export const defaultConfig = {
  breakpointMobile: 640,
  breakpointTablet: 960,
  breakpointLargeDesktop: 1280
};